/*
 * Copyright (c) 2022. CodeGen International (Pvt) Ltd. All Rights Reserved.
 *
 * This software is the confidential and proprietary information of CodeGen
 * International (Pvt) Ltd. ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only in accordance with the
 * terms of the license agreement you entered into with CodeGen International.
 *
 */

import {KeyControlAndAbstractSearchCriteria} from './key-control-and-abstract-search-criteria';

/**
 * @author lakshan
 * @since 08 Nov, 2022
 */

export class JobParameterSearchCriteria extends KeyControlAndAbstractSearchCriteria {
    jobName = '';
    parameterName = '';
}
